import React, { Fragment, useContext } from 'react';
import './App.scss';
import Header from './Header/Header';
import PageTitle from './PageTitle/PageTitle';
import Info from './Info/Info';
import CardForm from './CardForm/CardForm';
import Login from './Login/Login';
import BtnBuy from './BtnBuy/BtnBuy';
import Feedback from './Feedback/Feedback';
import Finish from './Finish/Finish';
import { Context } from './@context/Context';
import Loader from './Loader/Loader';

const renderStep = (subscribe) => {

    if (subscribe) {
        return <Finish />;
    }

    return (
        <Fragment>
            <Loader/>
            <PageTitle />
            <Info />
            <CardForm />
            <Login />
            <BtnBuy />
            <Feedback />
        </Fragment>
    );

};

const App = () => {
    const { state: { lastStep } } = useContext(Context);

    return (
        <Fragment>
            <Header />
            {
                renderStep(lastStep)
            }
        </Fragment>
    );
};

export default App;